module.exports = __webpack_public_path__ + "assets/img/0409.4650593e.png";